import { axios } from '@/utils/request'

export function sendProgramPartners (formData) {
    return axios({
        url: '/program-partner/',
        method: 'POST',
        data: formData
    })
}
